import { ROLE_USER } from '@/types/enums';
import { isRoles } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import BikeManagementAdminPage from './admin';
import BikeManagementOwnerPage from './owner';

export default observer(function BikeManagementPage() {
    return (
        <>
            { isRoles([ROLE_USER.BEST_BIKE_ADMIN, ROLE_USER.SYSTEM_ADMIN]) ?
                <BikeManagementAdminPage /> :
                <BikeManagementOwnerPage /> }
        </>
    );
});
